const AllocateIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_59_136)">
        <path
          d="M9 6.75V11.25"
          stroke="#1890FF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 9H11.25"
          stroke="#1890FF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 5.39999C6.59619 5.39999 7.6875 4.30869 7.6875 2.96249C7.6875 1.6163 6.59619 0.524994 5.25 0.524994C3.90381 0.524994 2.8125 1.6163 2.8125 2.96249C2.8125 4.30869 3.90381 5.39999 5.25 5.39999Z"
          stroke="#1890FF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.88127 7.13549C6.40877 6.98249 5.90477 6.89999 5.38127 6.89999C2.81552 6.89999 1.46702 8.88374 1.27502 11.4H6.88127"
          stroke="#1890FF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_59_136">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AllocateIcon
